<script>
    import { createEventDispatcher } from 'svelte';

    export let title = '';
    export let isOpen = false;

    const dispatch = createEventDispatcher();

    function onClick() {
        dispatch('click');
    }

</script>

<div on:click={onClick} class="ghwp-accordion__item-title">
    <span class="ghwp-accordion__item-title-text">{title}</span>
    <hr class="ghwp-accordion__item-title-line" />
    <div class="ghwp-collapsible-toggle">
        <button class="ghwp-collapsible-toggle-button" aria-expanded={isOpen}>
            <span class="ghwp-accordion__item-title-arrow" />
        </button>
    </div>
</div>

<style>
    .ghwp-accordion__item-title {
        cursor: pointer;
    }

</style>
